/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Sensor,
    SensorFromJSON,
    SensorFromJSONTyped,
    SensorToJSON,
} from './';

/**
 * 
 * @export
 * @interface Sensors
 */
export interface Sensors {
    /**
     * 
     * @type {Array<Sensor>}
     * @memberof Sensors
     */
    sensors: Array<Sensor>;
}

export function SensorsFromJSON(json: any): Sensors {
    return SensorsFromJSONTyped(json, false);
}

export function SensorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sensors {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sensors': ((json['sensors'] as Array<any>).map(SensorFromJSON)),
    };
}

export function SensorsToJSON(value?: Sensors | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sensors': ((value.sensors as Array<any>).map(SensorToJSON)),
    };
}


